<template>

  <div class="admin-body">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-row style="padding: 15px">
      <el-row class="main">
        <!--<el-row :gutter="10" style="min-height: 40px">-->
        <!--<el-col :xs="24" :sm="6" :md="4" :lg="4" align="left" style="margin-bottom: 5px">-->
        <!--<el-select v-model="watch_value" filterable placeholder="请选择排序" @change="sorting(watch_value)">-->
        <!--<el-option-->
        <!--v-for="item in watchdata"-->
        <!--:key="item.watch_id"-->
        <!--:label="item.watch_name"-->
        <!--:value="item.watch_id">-->
        <!--</el-option>-->
        <!--</el-select>-->
        <!--</el-col>-->

        <!--<el-col :xs="12" :sm="8" :md="6" :lg="6" style="margin-bottom: 5px" align="left">-->
        <!--<el-input-->
        <!--placeholder="请输入会员编号,手机号或公司名称"-->
        <!--v-model="selectkey"-->
        <!--clearable>-->
        <!--</el-input>-->

        <!--</el-col>-->
        <!--<el-col :xs="24" :sm="2" :md="2" :lg="2" align="left" style="margin-bottom: 5px">-->
        <!--<el-button type="primary" @click="getstart()">开始查询</el-button>-->
        <!--</el-col>-->

        <!--<el-col :xs="24" :sm="24" :md="12" :lg="12" align="right">-->
        <!--&lt;!&ndash;<el-button type="success" icon="el-icon-edit-outline" @click="">导出Excel表格</el-button>&ndash;&gt;-->
        <!--&lt;!&ndash;<el-button type="success" icon="el-icon-delete">回收站</el-button>&ndash;&gt;-->
        <!--&lt;!&ndash;<el-button type="primary" @click="">新增</el-button>&ndash;&gt;-->
        <!--</el-col>-->
        <!--<el-col :xs="24" :sm="24" :md="24" :lg="24" style="margin-bottom: 5px" align="left">-->
        <!--<el-date-picker-->
        <!--v-model="sstime"-->
        <!--type="daterange"-->
        <!--align="right"-->
        <!--unlink-panels-->
        <!--range-separator="至"-->
        <!--start-placeholder="开始日期"-->
        <!--end-placeholder="结束日期"-->
        <!--:picker-options="pickerOptions"-->
        <!--&gt;-->
        <!--</el-date-picker>-->
        <!--</el-col>-->
        <!--</el-row>-->

        <el-table
          border
          ref="multipleTable"
          align="left"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            prop="user_id"
            label="	用户ID"
          >
          </el-table-column>
       <el-table-column
            prop="nickname"
            label="	昵称"
          >
          </el-table-column>
          <el-table-column
            prop="phone"
            label="	手机号"
          >
          </el-table-column>


          <el-table-column
            label="下单时间"
          >
            <template slot-scope="scope">
              {{ scope.row.create_time}}
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            label="支付方式">-->
<!--            <template slot-scope="scope">-->
<!--            {{scope.row.pay_type=='1'?'支付宝':scope.row.pay_type=='2'?'微信':scope.row.pay_type=='3'?'余额':''}}-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
            label="下单类别">
            <template slot-scope="scope">
             {{scope.row.content}}
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            label="操作"-->
<!--            width="140">-->
<!--            <template slot-scope="scope">-->
<!--              <el-button  @click="editvalue(scope.row)" size="small" type="text">-->
<!--                确认服务-->
<!--              </el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>

        <el-row style="margin-top: 20px">

          <el-col :xs="24" :sm="24" :md="24" :lg="24" align="right">
            <el-pagination
              style="text-align: right"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="datatotal">
            </el-pagination>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px;">

        </el-row>
      </el-row>
    </el-row>

    <!--编辑-->
    <el-dialog title="编辑" width="450px" :visible.sync="detailVisible" :modal-append-to-body="false">
      <el-form >
        <el-form-item label="价格" :label-width="formLabelWidth" >
          <el-input clearable v-model="editData.price" type="number" auto-complete="off" placeholder="请输入价格" required></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitedit()">确 定</el-button>
      </div>
    </el-dialog>

    <div id="container" class="addmap"></div>
    <template><span v-loading.fullscreen.lock="fullscreenLoading"></span></template>
  </div>
</template>

<script>

  export default {
    name: "OrderListH5",
    mounted() {
      if (!this.$store.state.login.in) {
        this.$router.push({name: "login", params: {userId: 123}})
      }
      this.getstart()
    },
    data() {
      return {
        detailData:[],
        pickerOptions: {
          shortcuts: [{
            text: '昨天购买',
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, start]);
            }
          }, {
            text: '前天购买',
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
              picker.$emit('pick', [start, start]);
            }
          }
            , {
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                /* 获取系统当前时间*/
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                /* getTime（）1970.1.1至今毫秒数。setTime（x）给start添加x毫秒*/
                picker.$emit('pick', [start, end]);
              }
            }],
        },
        watchdata: [{
          watch_id: 'order.addtime desc',
          watch_name: '下单时间降序'
        }, {
          watch_id: 'order.addtime asc',
          watch_name: '下单时间升序'
        }, {
          watch_id: 'order.total desc',
          watch_name: '下单金额降序'
        }, {
          watch_id: 'order.total asc',
          watch_name: '下单金额升序'
        },],
        watch_value: '下单时间降序',
        watch: 'order.addtime desc',
        sstime: [],

        fullscreenLoading: false,
        tableData: [],
        pagesize: 10,
        currentPage: 1,
        selectkey: '',
        datatotal: 0,
        formLabelWidth: '150px',
        detailVisible: false,
        editdata: {
          category_name: '',
          category_type: '',
        },
        //shijian
        addtime1: '',
        addtime2: '',
        addtimeop: 0,
        editData:[],

      }
    },
    watch: {
      sstime() {
        let thi = this
        if (thi.addtimeop == 0) {
          // thi.addtimeop=1
          console.log(thi.sstime)
          if (thi.sstime) {
            // console.log(thi.sstime.length)
            if (typeof(thi.sstime[0]) == 'number') {
              thi.addtime1 = Math.floor(thi.sstime[0] / 1000)
              thi.addtime2 = Math.floor(thi.sstime[1] / 1000)
            } else {
              thi.addtime1 = Math.floor(thi.sstime[0].getTime() / 1000)
              thi.addtime2 = Math.floor(thi.sstime[1].getTime() / 1000)
            }
          } else {
            thi.addtime1 = '0000000000'
            thi.addtime2 = '9999999999'
          }
          thi.getstart()
        }
        console.log(thi.addtime1, thi.addtime2)
      }
    },
    methods: {

      //绑定表格数据，分页
      getstart() {
        let thi = this
        thi.fullscreenLoading = true
        /*全屏幕正在加载*/
        const prams = {
          page: thi.currentPage, /*当前页码*/
          pageSize: thi.pagesize, /*每页显示多少条数据*/
          // key: thi.selectkey, /*名字或电话查询字符串*/
          // starttime: thi.addtime1,
          // stoptime: thi.addtime2,
          // sort_by: this.watch,
        }
        this.$http.post(global.posturl.host + global.posturl.listAppOrder, prams
        ).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          var qtotal = response.data.Total
          if (qcode == 200) {
            thi.tableData = qdata
            /* 绑定表格数据*/
            thi.datatotal = qtotal
            /*总条目数*/
          }
          thi.fullscreenLoading = false
          /*全屏幕正在加载*/
        }).catch(function (error) {
          console.log(error)
        });
      },
      // 显示编辑
      edit(data) {
        let thi = this
        thi.detailVisible=true
        thi.editData=JSON.parse(JSON.stringify(data))
      },
      // 提交编辑
      submitedit() {
        let thi=this
        thi.fullscreenLoading = true
        thi.$http.post(global.posturl.host + global.posturl.jjfsPriceEdit,
          thi.editData
        ).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          if (qcode == 200) {
            thi.detailVisible = false
            thi.fullscreenLoading = false
            thi.getstart()
            thi.$message({
              message: qmsg,
              type: 'success',
            });
          } else {
            thi.$message({
              type: 'warning',
              message: qmsg
            });
            thi.fullscreenLoading = false
          }
        }).catch(function (error) {
          console.log(error)
        });

      },


      //跳转页面
      viewwindow(row) {
        this.$router.push({name: 'orderinfo', params: {row}})
      },

      //排序
      sorting(watchid) {
        this.watch = watchid
        this.getstart()
      },


      //选择展示数量
      handleSizeChange(val) {
        this.pagesize = val
        this.getstart()
      },
      //分页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getstart()
      },

      //格式化日期
      formatDate(date) {
        if (!date) {
          return "无"
        }
        Date.prototype.toLocaleString = function () {
          return this.getFullYear() + "-" + (this.getMonth() + 1) + "-" + this.getDate() + " " + this.getHours() + ":" + this.getMinutes() + ":" + this.getSeconds();
        };
        var unixTimestamp = new Date(date * 1000)
        return unixTimestamp.toLocaleString();
      },
    }
  }

  /* export default {
     name: "Member",
     data() {
       return {}
     }
     }*/
</script>

<style scoped>
  .admin-body {
    /*background-color: white;*/
    width: 100%;
  }

  .main {
    background-color: white;
    min-height: 500px;
    padding: 10px;
    border: #EDEDED 1px solid;
    border-radius: 5px;
  }

  .block {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/page/order/OrderListH5.vue